var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_24390)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#E4E7EC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 20C30 19.07 30 18.605 29.8978 18.2235C29.6204 17.1883 28.8117 16.3796 27.7765 16.1022C27.395 16 26.93 16 26 16C25.07 16 24.605 16 24.2235 16.1022C23.1883 16.3796 22.3796 17.1883 22.1022 18.2235C22 18.605 22 19.07 22 20M26.8 30.5H31.7C31.98 30.5 32.12 30.5 32.227 30.4455C32.3211 30.3976 32.3976 30.3211 32.4455 30.227C32.5 30.12 32.5 29.98 32.5 29.7V27.3C32.5 27.02 32.5 26.88 32.4455 26.773C32.3976 26.6789 32.3211 26.6024 32.227 26.5545C32.12 26.5 31.98 26.5 31.7 26.5H26.8C26.52 26.5 26.38 26.5 26.273 26.5545C26.1789 26.6024 26.1024 26.6789 26.0545 26.773C26 26.88 26 27.02 26 27.3V29.7C26 29.98 26 30.12 26.0545 30.227C26.1024 30.3211 26.1789 30.3976 26.273 30.4455C26.38 30.5 26.52 30.5 26.8 30.5ZM20.8 34H31.2C32.8802 34 33.7202 34 34.362 33.673C34.9265 33.3854 35.3854 32.9265 35.673 32.362C36 31.7202 36 30.8802 36 29.2V24.8C36 23.1198 36 22.2798 35.673 21.638C35.3854 21.0735 34.9265 20.6146 34.362 20.327C33.7202 20 32.8802 20 31.2 20H20.8C19.1198 20 18.2798 20 17.638 20.327C17.0735 20.6146 16.6146 21.0735 16.327 21.638C16 22.2798 16 23.1198 16 24.8V29.2C16 30.8802 16 31.7202 16.327 32.362C16.6146 32.9265 17.0735 33.3854 17.638 33.673C18.2798 34 19.1198 34 20.8 34Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_24390",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_24390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_24390",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/acceptIcon.0c5844e5515365e22067ac8f8a6bfa75.svg";
export { ForwardRef as ReactComponent };